import { SchoolGroup } from "@core/models/domain/group.domain";
export interface GroupState {
  groups: SchoolGroup[];
  // Cache metadata consumed by the loadGroupsIfNeeded effect (see group.effects.ts).
  loaded: boolean;
  lastLoadedAt: number | null;
  loading: boolean;
  error: any;
}

export const initialGroupState: GroupState = {
  groups: [],
  loaded: false,
  lastLoadedAt: null,
  loading: false,
  error: null
};